module.exports = __webpack_public_path__ + "static/media/logo.08a730d0.svg";